import React from 'react';
import { Building2, ChevronDown, Check } from 'lucide-react';
import { useStudio } from '../contexts/StudioContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const StudioSelector = () => {
  const { studios, selectedStudio, selectStudio, loading } = useStudio();

  if (loading) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 text-sm text-gray-500">
        <Building2 className="h-4 w-4 animate-pulse" />
        <span>Laden...</span>
      </div>
    );
  }

  if (studios.length === 0) {
    return null;
  }

  // If only one studio, show it without dropdown
  if (studios.length === 1) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-teal-50 text-teal-700 rounded-lg text-sm font-medium">
        <Building2 className="h-4 w-4" />
        <span>{studios[0].short_name || studios[0].name}</span>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="flex items-center gap-2 bg-teal-50 border-teal-200 text-teal-700 hover:bg-teal-100 hover:text-teal-800"
          data-testid="header-studio-selector"
        >
          <Building2 className="h-4 w-4" />
          <span className="font-medium">
            {selectedStudio?.short_name || selectedStudio?.name || 'Studio wählen'}
          </span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {studios.map((studio) => (
          <DropdownMenuItem
            key={studio.id}
            onClick={() => selectStudio(studio)}
            className="flex items-center justify-between cursor-pointer"
            data-testid={`header-studio-${studio.short_name || studio.id}`}
          >
            <div className="flex items-center gap-2">
              <Building2 className="h-4 w-4 text-gray-500" />
              <div>
                <div className="font-medium">{studio.name}</div>
                {studio.address && (
                  <div className="text-xs text-gray-500 truncate max-w-[180px]">
                    {studio.address}
                  </div>
                )}
              </div>
            </div>
            {selectedStudio?.id === studio.id && (
              <Check className="h-4 w-4 text-teal-600" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default StudioSelector;
